<div class="qira-sidebar__inner">
  <a class="qira-sidebar__brand" routerLink="/security-deposit" aria-label="Qira Security Deposit Platform">
    <img class="qira-sidebar__brand-logo qira-sidebar__brand-logo--light" src="./assets/images/qira-logo-black-blue.svg"
      alt="Qira" />
    <img class="qira-sidebar__brand-logo qira-sidebar__brand-logo--dark" src="./assets/images/qira-logo-white-blue.png"
      alt="Qira" />
    <span class="qira-sidebar__brand-subtitle">Security Deposit Platform</span>
  </a>

  <nav class="qira-sidebar__nav" aria-label="Security deposit navigation">
    <ng-container *ngFor="let group of navGroups; let last = last">
      <a *ngFor="let item of group.items" [routerLink]="item.route" [queryParams]="item.queryParams ?? null"
        routerLinkActive="is-active" [routerLinkActiveOptions]="{ exact: item.exact ?? false }"
        class="qira-sidebar__item" [class.qira-sidebar__item--sub]="item.isSubItem">
        <mat-icon *ngIf="item.svgIcon; else fontIcon" class="qira-sidebar__icon" [svgIcon]="item.svgIcon"></mat-icon>
        <ng-template #fontIcon><mat-icon class="qira-sidebar__icon">{{ item.icon }}</mat-icon></ng-template>
        <span class="qira-sidebar__label">{{ item.label }}</span>
      </a>
      <mat-divider class="qira-sidebar__divider" *ngIf="!last"></mat-divider>
    </ng-container>
  </nav>

  <a class="qira-sidebar__guide" href="./assets/files/Qira-Security-Deposit-Getting-Started.html" target="_blank"
    rel="noopener">
    <mat-icon class="qira-sidebar__icon">school</mat-icon>
    <span class="qira-sidebar__label">Getting Started Guide</span>
    <!-- <mat-icon class="qira-sidebar__guide-arrow">open_in_new</mat-icon> -->
  </a>
</div>